import { TFunction } from 'i18next';
import { Maybe, TiktokAdDetailReport, TikTokAdReportSummary, TikTokAdStatus } from '@anytag/graphql';
import { BadgeProps } from '@anyui/core';
import { AdCampaignReportRowData, AdCampaignReportStats } from './types';

export const getAdReportStatusColumnProps = (status: Maybe<TikTokAdStatus> | undefined, t: TFunction): BadgeProps => {
  switch (status) {
    case TikTokAdStatus.ENABLE:
      return { children: t('Option.Active'), color: 'green' };
    case TikTokAdStatus.DISABLE:
      return { children: t('Option.Inactive'), color: 'zinc' };
    default:
      return { children: null, color: 'zinc' };
  }
};

const getAdReportStats = (stats?: TikTokAdReportSummary | null): AdCampaignReportStats => ({
  adBudget: stats?.adBudget ?? null,
  adClicks: stats?.adClicks ?? null,
  adComments: stats?.adComments ?? null,
  adCost: stats?.adCost ?? null,
  adCostPer1000Reached: stats?.adCostPer1000Reached ?? null,
  adCostPerResult: stats?.adCostPerResult ?? null,
  adCpc: stats?.adCpc ?? null,
  adCpm: stats?.adCpm ?? null,
  adCtr: stats?.adCtr ?? null,
  adEngagements: stats?.adEngagements ?? null,
  adEr: stats?.adEr ?? null,
  adFollows: stats?.adFollows ?? null,
  adFrequency: stats?.adFrequency ?? null,
  adImpressions: stats?.adImpressions ?? null,
  adLikes: stats?.adLikes ?? null,
  adReach: stats?.adReach ?? null,
  adResult: stats?.adResult ?? null,
  adResultRate: stats?.adResultRate ?? null,
  adShares: stats?.adShares ?? null,
  averageVideoPlay: stats?.averageVideoPlay ?? null,
  averageVideoPlayPerUser: stats?.averageVideoPlayPerUser ?? null,
  interactiveAddOnDestinationClicks: stats?.interactiveAddOnDestinationClicks ?? null,
  interactiveAddOnImpressions: stats?.interactiveAddOnImpressions ?? null,
  videoPlayActions: stats?.videoPlayActions ?? null,
  videoViewsP25: stats?.videoViewsP25 ?? null,
  videoViewsP50: stats?.videoViewsP50 ?? null,
  videoViewsP75: stats?.videoViewsP75 ?? null,
  videoViewsP100: stats?.videoViewsP100 ?? null,
  videoWatched2s: stats?.videoWatched2s ?? null,
  videoWatched6s: stats?.videoWatched6s ?? null
});

export const formatTiktokAdCampaignReportData = (
  data: readonly TiktokAdDetailReport[],
  summary?: TikTokAdReportSummary | null
) =>
  [
    { className: 'total-row', stats: getAdReportStats(summary) },
    ...data.map<AdCampaignReportRowData>((item) => ({
      stats: getAdReportStats(item),
      adCampaignInfo: {
        adId: item.adId,
        adName: item.adName,
        status: item.status,
        postId: item.postId,
        campaignId: item.campaignId,
        adCampaignId: item.adCampaignId,
        adCampaignName: item.adCampaignName
      }
    }))
  ] satisfies AdCampaignReportRowData[];
